(() => {
  'use strict';
  const number=(value,fallback,min,max)=>Number.isFinite(Number(value))?Math.min(max,Math.max(min,Number(value))):fallback;
  const rules={
    smsCountries(config){
      if(config.smsEnabled!==true)return [];
      const enabled=Array.isArray(config.smsCountries)?config.smsCountries.filter(value=>['US','CA','GB','AU'].includes(value)):[];
      const country=typeof config.storefrontCountry==='string'?config.storefrontCountry.trim().toUpperCase():'';
      return enabled.includes(country)?enabled:[];
    },
    dismissed(config,state,now){
      const days=number(config.dismissDays,7,0,3650);
      return Boolean(state.closedAt)&&now-Number(state.closedAt)<days*86400000;
    },
    eligible(config,state,visit){
      if(config.mode==='off'||visit.opened||visit.hidden)return false;
      if(config.hideCompleted&&state.completed)return false;
      if(rules.dismissed(config,state,visit.now))return false;
      if(visit.elapsed<number(config.delay,8,0,3600)*1000)return false;
      if(config.scrollEnabled&&visit.scroll<number(config.scrollPercent,50,0,100))return false;
      if(config.pagesEnabled&&visit.pages<number(config.pageCount,2,1,1000))return false;
      return true;
    },
    payload(config,channel,input){
      if(channel==='sms')return {shop_id:(config.postscriptShopId||'').trim(),keyword_id:(config.postscriptKeywordId||'').trim(),phone:input.phone};
      if(channel!=='email')throw new Error('Unsupported signup channel.');
      const attributes={
        email:input.email,
        properties:{bastion_popup_design:input.mode,bastion_popup_reward:input.mystery?'mystery':input.reward,bastion_popup_mystery:input.mystery},
        subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}
      };
      return {data:{type:'subscription',attributes:{custom_source:'Bastion '+(input.mode==='memory'?'Memory Match':'Scratch & Win')+' Pop-Up',profile:{data:{type:'profile',attributes}}},relationships:{list:{data:{type:'list',id:config.emailList}}}}};
    },
    ready(config){
      if(!/^[a-zA-Z0-9]{4,12}$/.test(config.siteId||'')||!/^[a-zA-Z0-9]{4,12}$/.test(config.emailList||''))return false;
      if(!rules.smsCountries(config).length)return true;
      return [config.postscriptShopId,config.postscriptKeywordId].every(value=>typeof value==='string'&&/^[1-9]\d{0,19}$/.test(value.trim()));
    }
  };
  if(typeof module!=='undefined'&&module.exports){module.exports=rules;return;}
  if(customElements.get('bastion-welcome-popup'))return;
  const scripts=new Map(),fonts=new Map();
  const read=(storage,key,fallback)=>{try{return JSON.parse(storage.getItem(key))||fallback;}catch{return fallback;}};
  const write=(storage,key,value)=>{try{storage.setItem(key,JSON.stringify(value));}catch{}};
  const storage=type=>{try{return window[type];}catch{return {getItem(){return null;},setItem(){}};}};
  const local=storage('localStorage'),session=storage('sessionStorage');
  const dismissalCookie=key=>encodeURIComponent(key+':closedAt');
  const readState=(key,fallback)=>{
    const state=read(local,key,fallback);
    let cookieTime=0;
    try{
      const prefix=dismissalCookie(key)+'=',cookie=document.cookie.split(';').map(value=>value.trim()).find(value=>value.startsWith(prefix));
      cookieTime=cookie?Number(cookie.slice(prefix.length))||0:0;
    }catch{}
    const closedAt=Math.max(Number(state.closedAt)||0,cookieTime);
    return closedAt?{...state,closedAt}:state;
  };
  const rememberDismissal=(key,closedAt,days)=>{
    try{
      document.cookie=dismissalCookie(key)+'='+closedAt+'; Max-Age='+Math.ceil(number(days,7,0,3650)*86400)+'; Path=/; SameSite=Lax'+(location.protocol==='https:'?'; Secure':'');
    }catch{}
  };
  function script(url){
    if(!scripts.has(url))scripts.set(url,new Promise((resolve,reject)=>{
      const element=document.createElement('script');element.src=url;element.async=true;
      const fail=()=>{clearTimeout(timeout);scripts.delete(url);element.remove();reject(new Error('Pop-up script unavailable. Please try again.'));};
      const timeout=setTimeout(fail,20000);
      element.onload=()=>{clearTimeout(timeout);resolve();};element.onerror=fail;document.head.append(element);
    }));
    return scripts.get(url);
  }
  function font(url,weight){
    if(!fonts.has(url)){
      const face=new FontFace('BastionPopup','url("'+url+'")',{weight,display:'swap'});
      document.fonts.add(face);fonts.set(url,face.load().catch(()=>null));
    }
    return fonts.get(url);
  }
  class BastionWelcomePopup extends HTMLElement{
    connectedCallback(){
      if(this.started)return;
      this.started=true;this.stopped=false;this.config=JSON.parse(this.dataset.config);this.template=this.querySelector('template');
      this.key='bastion-popup-v1:'+(this.config.previewOnly?'preview-186024100055':'subscribers');
      this.state=readState(this.key,{});this.opened=false;this.loading=false;this.timer=0;this.scrollFrame=0;
      this.start=performance.now();this.controller=new AbortController();this.inertNodes=[];this.wasFocused=null;this.locked=false;
      const cfg=this.config;
      cfg.smsCountries=rules.smsCountries(cfg);
      for(const field of ['successUrl','smsTerms','smsPrivacy']){try{const url=new URL(cfg[field]||'',location.origin);cfg[field]=cfg[field]&&['http:','https:'].includes(url.protocol)?url.href:'';}catch{cfg[field]='';}}
      if(cfg.mode==='off')return;
      if(cfg.previewOnly&&!cfg.designMode&&!cfg.isDraft)return;
      if(!cfg.previewOnly&&!cfg.designMode&&!rules.ready(cfg))return;
      const pageKey=this.key+':pages',paths=read(session,pageKey,[]);
      const path=location.pathname;
      const visited=Array.isArray(paths)?paths.filter(x=>typeof x==='string').slice(-1000):[];
      if(!visited.includes(path))visited.push(path);
      if(!cfg.designMode)write(session,pageKey,visited);
      this.pages=visited.length;
      const options={signal:this.controller.signal};
      this.check=()=>this.maybeShow();
      if(cfg.scrollEnabled)window.addEventListener('scroll',()=>{
        if(!this.scrollFrame)this.scrollFrame=requestAnimationFrame(()=>{this.scrollFrame=0;this.maybeShow();});
      },{...options,passive:true});
      document.addEventListener('visibilitychange',this.check,options);
      if(!cfg.designMode)window.addEventListener('storage',e=>{if(e.key===this.key||e.key===null)this.check();},options);
      if(cfg.designMode){
        document.addEventListener('shopify:section:select',e=>{if(e.detail.sectionId===cfg.sectionId)this.show(true);},options);
        document.addEventListener('shopify:section:deselect',e=>{if(e.detail.sectionId===cfg.sectionId)this.experience?.destroy();},options);
        this.show(true);
      }else{
        this.timer=setTimeout(this.check,number(cfg.delay,8,0,3600)*1000);this.maybeShow();
      }
    }
    disconnectedCallback(){
      this.stopped=true;this.controller?.abort();clearTimeout(this.timer);cancelAnimationFrame(this.scrollFrame);this.experience?.destroy();this.unlock();
    }
    maybeShow(){
      if(this.stopped||this.loading)return;
      if(this.canShow())this.show();
    }
    canShow(){
      this.state=readState(this.key,this.state);
      if(!this.config.designMode&&(rules.dismissed(this.config,this.state,Date.now())||(this.config.hideCompleted&&this.state.completed))){
        if(this.locked)this.experience?.destroy();
        return false;
      }
      const distance=Math.max(0,document.documentElement.scrollHeight-innerHeight);
      const scrolled=distance?Math.min(100,scrollY/distance*100):0;
      return rules.eligible(this.config,this.state,{now:Date.now(),elapsed:performance.now()-this.start,scroll:scrolled,pages:this.pages,opened:this.opened,hidden:document.hidden});
    }
    async show(force=false){
      if(this.stopped||this.loading||(!force&&!this.canShow()))return;
      if(this.experience){this.experience.open();return;}
      this.loading=true;
      try{
        const cfg=this.config,root=this.shadowRoot||this.attachShadow({mode:'open'});
        root.replaceChildren();
        const css=document.createElement('link');css.rel='stylesheet';css.href=cfg.styleUrl;
        const styled=new Promise((resolve,reject)=>{css.onload=resolve;css.onerror=reject;});
        root.append(css);
        await Promise.all([styled,script(cfg.scriptUrl),font(cfg.assets.regular,'400'),font(cfg.assets.semibold,'600 900')]);
        if(this.stopped||(!force&&!this.canShow()))return;
        root.append(this.template.content.cloneNode(true));
        this.experience=window.BastionPopupExperience(root,cfg,{
          open:()=>this.lock(),
          close:record=>{if(record&&!cfg.designMode){this.state=readState(this.key,this.state);this.state.closedAt=Date.now();write(local,this.key,this.state);rememberDismissal(this.key,this.state.closedAt,cfg.dismissDays);}this.unlock();},
          completed:reason=>{if(!cfg.designMode){this.state.completed=true;this.state.reason=reason;write(local,this.key,this.state);}},
          subscribe:(channel,input,container)=>this.subscribe(channel,input,container),
          cancelSms:()=>this.cancelSms?.()
        });
        this.opened=true;this.experience.open();
      }catch(problem){
        console.warn('Bastion pop-up could not load.');this.unlock();
      }finally{this.loading=false;}
    }
    lock(){
      if(this.locked)return;
      this.locked=true;this.wasFocused=document.activeElement;
      this.previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';
      let branch=this;
      while(branch.parentElement&&branch.parentElement!==document.documentElement){
        for(const node of branch.parentElement.children){
          if(node!==branch&&!['SCRIPT','STYLE','LINK'].includes(node.tagName)&&!node.inert){node.inert=true;this.inertNodes.push(node);}
        }
        branch=branch.parentElement;
      }
    }
    unlock(){
      if(!this.locked)return;
      this.locked=false;document.body.style.overflow=this.previousOverflow;
      this.inertNodes.forEach(node=>{node.inert=false;});this.inertNodes=[];
      if(this.wasFocused?.isConnected)this.wasFocused.focus({preventScroll:true});
    }
    async submitSmsForm(input,signal){
      if(signal.aborted)throw new DOMException('Cancelled','AbortError');
      if(window.navigator?.onLine===false)throw new Error('You appear to be offline. Reconnect and try again, or choose No Thanks.');
      return new Promise((resolve,reject)=>{
        const frame=document.createElement('iframe'),form=document.createElement('form');
        frame.name='bastion-postscript-'+crypto.randomUUID();frame.title='SMS signup response';frame.hidden=true;frame.tabIndex=-1;
        form.action='https://api.postscript.io/subscribe/form';form.method='post';form.target=frame.name;form.hidden=true;
        for(const [name,value] of Object.entries(rules.payload(this.config,'sms',input))){
          const field=document.createElement('input');field.type='hidden';field.name=name;field.value=value;form.append(field);
        }
        let submitted=false,timer;
        const clean=()=>{clearTimeout(timer);signal.removeEventListener('abort',abort);window.removeEventListener('pagehide',clean);form.remove();frame.remove();};
        const fail=error=>{clean();reject(error);};
        const abort=()=>fail(new DOMException('Cancelled','AbortError'));
        signal.addEventListener('abort',abort,{once:true});
        window.addEventListener('pagehide',clean,{once:true});
        frame.addEventListener('load',()=>{
          if(submitted){clean();return;}
          if(signal.aborted){abort();return;}
          submitted=true;clearTimeout(timer);
          try{
            form.submit();form.remove();
            timer=setTimeout(clean,30000);
            resolve({status:'submitted_unverified'});
          }catch{fail(new Error('Your text signup could not be sent. Try again, or choose No Thanks.'));}
        });
        frame.addEventListener('error',()=>fail(new Error('Your text signup could not be sent. Try again, or choose No Thanks.')));
        timer=setTimeout(()=>fail(new Error('Your text signup could not start. Try again, or choose No Thanks.')),8000);
        document.body.append(form,frame);
      });
    }
    async subscribe(channel,input,container){
      const cfg=this.config;
      if(channel==='sms'&&!rules.smsCountries(cfg).includes(input.country))throw new Error('SMS signup is unavailable for this country. Your email offer is still yours.');
      if(cfg.previewOnly||cfg.designMode){await new Promise(resolve=>setTimeout(resolve,450));return;}
      if(!rules.ready(cfg))throw new Error('Signup is temporarily unavailable. Please try again later.');
      const controller=new AbortController();let timeout;
      const cancel=()=>controller.abort();
      if(channel==='sms'){this.cancelSms?.();this.cancelSms=cancel;}
      try{
        if(channel==='sms')return await this.submitSmsForm(input,controller.signal);
        const payload=rules.payload(cfg,channel,input);
        if(controller.signal.aborted)throw new DOMException('Cancelled','AbortError');
        timeout=setTimeout(()=>controller.abort(),15000);
        const result=await fetch('https://a.klaviyo.com/client/subscriptions?company_id='+encodeURIComponent(cfg.siteId),{
          method:'POST',headers:{accept:'application/vnd.api+json','content-type':'application/vnd.api+json',revision:'2026-07-15'},
          credentials:'omit',referrerPolicy:'strict-origin',signal:controller.signal,body:JSON.stringify(payload)
        });
        if(result.status!==202)throw new Error('That didn’t go through. Please try again.');
      }catch(problem){
        if(problem.name==='AbortError')throw new Error('This is taking a little longer. Please try again.');
        throw problem;
      }finally{clearTimeout(timeout);if(channel==='sms'&&this.cancelSms===cancel)this.cancelSms=null;}
    }
  }
  customElements.define('bastion-welcome-popup',BastionWelcomePopup);
})();
